module.exports = __webpack_public_path__ + "img/nav-logo.40d67852.png";